import { Modal, Grid } from '@pankod/refine-antd'
import { useState } from 'react'

const LatexEquationEditorModal = () => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false)
  const [loaded, setLoaded] = useState<boolean>(false)
  const showModal = () => setIsModalOpen(true)
  const cancelModal = () => setIsModalOpen(false)
  const handleOnLoad = () => setLoaded(true)
  const breakpoint = Grid.useBreakpoint()
  const isMobile = !breakpoint.lg

  return (
    <>
      <p style={{ textAlign: 'start', fontSize: 12 }}>
        <a onClick={showModal} style={{ color: '#3C9EDC' }}>
          Click here
        </a>{' '}
        to open the latex equation editor
      </p>
      <Modal visible={isModalOpen} onCancel={cancelModal} onOk={cancelModal} width={isMobile ? '95%' : '60%'} style={{ height: 550 }}>
        <div>
          <p style={{ color: '#00436D', fontSize: 12 }}>
            Kindly download the equation in PNG format.{' '}
            <span style={{ color: '#00436D', fontSize: 10, fontWeight: 'bold' }}>
              (You can obtain the PNG file by clicking on the dropdown menu in the last column and choosing the PNG option).
            </span>{' '}
            <br />
            Utilize the downloaded PNG image of the equation in the editor .
          </p>
        </div>
        {!loaded && <p style={{ textAlign: 'center' }}>Loading......</p>}
        <div
          style={{
            overflow: 'hidden',
            width: isMobile ? '100%' : '786px',
            height: '520px',
            overflowX: isMobile ? 'auto' : 'hidden',
            scrollbarWidth: 'none',
            border: '1px solid gray',
            borderRadius: '5px',
          }}
        >
          <iframe
            src="https://editor.codecogs.com"
            width="1000"
            height="1000"
            style={{ position: 'relative', top: '-280px', left: '-192px' }}
            onLoad={handleOnLoad}
            scrolling="no"
          />
        </div>

        {/* <iframe src="https://latex.codecogs.com/eqneditor/editor.php" onLoad={handleOnLoad} width="100%" height="500"></iframe> */}
      </Modal>
    </>
  )
}

export default LatexEquationEditorModal
